export const IconTwitter = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.0584 17.3333L25.3245 29.7434L16 39.8333H18.0987L26.2625 30.9992L32.8584 39.8333H40L30.2123 26.7254L38.8916 17.3333H36.7929L29.2747 25.4691L23.2 17.3333H16.0584ZM19.1447 18.8817H22.4255L36.9133 38.285H33.6325L19.1447 18.8817Z"
      fill="white"
    />
  </svg>
);
